import { ArrowUpRight, Facebook, Instagram, Mail, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const phones = ["0726 423 784", "0723 696 188"];

const Footer = () => (
  <footer className="bg-ink text-paper">
    <div className="bg-sun text-ink">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-6 py-7 md:flex-row md:items-center md:justify-between">
        <div>
          <p className="font-display text-2xl font-bold">Hai să găsim cursul potrivit.</p>
          <p className="text-ink/70">Spune-ne clasa și materia, iar noi îți explicăm opțiunile.</p>
        </div>
        <Link to="/contact" className="inline-flex w-fit items-center gap-2 rounded-full bg-ink px-6 py-3 font-bold text-paper transition-transform duration-300 hover:-translate-y-0.5">
          Vorbește cu noi <ArrowUpRight className="h-5 w-5" />
        </Link>
      </div>
    </div>

    <div className="mx-auto max-w-7xl px-6 py-14">
      <div className="grid gap-12 md:grid-cols-[1.15fr_1fr_0.8fr]">
        <div>
          <Link to="/" className="inline-flex items-center gap-3">
            <span className="h-16 w-16 overflow-hidden rounded-2xl bg-paper">
              <img src="/logo.jpg" alt="" className="h-full w-full scale-125 object-cover" />
            </span>
            <span>
              <span className="block font-display text-2xl font-bold">Centrul Progres</span>
              <span className="text-sm text-paper/65">Învățare cu ritm și încredere</span>
            </span>
          </Link>
          <p className="mt-5 max-w-md text-paper/70">
            Cursuri de limbi străine și meditații la română și matematică pentru elevi din București.
          </p>
          <div className="mt-6 flex gap-3">
            <a href="https://m.facebook.com/centru.progres/" target="_blank" rel="noopener noreferrer" aria-label="Centrul Progres pe Facebook" className="flex h-11 w-11 items-center justify-center rounded-full bg-paper/10 transition-colors hover:bg-paper/20">
              <Facebook className="h-5 w-5" />
            </a>
            <a href="https://www.instagram.com/centru.progres?igsh=bG1mZWgwZjdld2d3" target="_blank" rel="noopener noreferrer" aria-label="Centrul Progres pe Instagram" className="flex h-11 w-11 items-center justify-center rounded-full bg-paper/10 transition-colors hover:bg-paper/20">
              <Instagram className="h-5 w-5" />
            </a>
          </div>
        </div>

        <div>
          <h2 className="mb-5 text-lg font-bold">Contact</h2>
          <address className="space-y-4 not-italic text-paper/75">
            <div className="flex items-start gap-3">
              <Phone className="mt-1 h-5 w-5 flex-shrink-0 text-sun" />
              <div>{phones.map((phone) => <a key={phone} href={`tel:${phone.replace(/\s/g, '')}`} className="block hover:text-paper">{phone}</a>)}</div>
            </div>
            <a href="mailto:contact@centrulprogres.com" className="flex items-center gap-3 hover:text-paper">
              <Mail className="h-5 w-5 text-sun" /> contact@centrulprogres.com
            </a>
            <p className="flex items-start gap-3">
              <MapPin className="mt-1 h-5 w-5 flex-shrink-0 text-sun" />
              Șoseaua Colentina nr. 16, Complex Rose Garden, Bloc B4, parter, București
            </p>
          </address>
        </div>

        <div>
          <h2 className="mb-5 text-lg font-bold">Explorează</h2>
          <nav aria-label="Navigație subsol" className="flex flex-col gap-3 text-paper/70">
            <Link to="/packages" className="hover:text-paper">Cursuri și prețuri</Link>
            <Link to="/teachers" className="hover:text-paper">Profesorii noștri</Link>
            <Link to="/colaborari" className="hover:text-paper">Cum colaborăm</Link>
            <Link to="/contact" className="hover:text-paper">Contact</Link>
            <Link to="/terms-conditions" className="hover:text-paper">Termeni și condiții</Link>
          </nav>
        </div>
      </div>

      <div className="mt-12 flex flex-col gap-2 border-t border-paper/15 pt-6 text-sm text-paper/55 sm:flex-row sm:items-center sm:justify-between">
        <p>© {new Date().getFullYear()} Centru Progres S.R.L.</p>
        <p>București, Sector 2</p>
      </div>
    </div>
  </footer>
);

export default Footer;
